export default function Marquee({ items, dark = true }) {
  const content = items.join("  •  ");
  return (
    <div
      data-testid="marquee-band"
      className={`w-full overflow-hidden py-4 ${dark ? "bg-teal text-cream" : "bg-mint text-teal-dark"}`}
      aria-hidden="false"
    >
      <div className="flex w-max animate-marquee">
        {[0, 1].map((dup) => (
          <span
            key={dup}
            aria-hidden={dup === 1}
            className="whitespace-nowrap font-mono text-xs md:text-sm uppercase tracking-[0.25em] px-6"
          >
            {content}  •&nbsp;
          </span>
        ))}
      </div>
    </div>
  );
}
